var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartRayComponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1012,
    height: 1038,
    viewBox: "0 0 1012 1038",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ray"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21527",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter0_f_2131_17522)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.503,
    cy: 537.224,
    rx: 319.067,
    ry: 73.9023,
    transform: "rotate(83.6275 540.503 537.224)",
    fill: "url(#paint0_linear_2131_17522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21532",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter1_f_2131_17522)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492.422,
    cy: 595.033,
    rx: 371.182,
    ry: 19.7009,
    transform: "rotate(90.8759 492.422 595.033)",
    fill: "url(#paint1_linear_2131_17522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21530",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter2_f_2131_17522)"
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 498.929,
    cy: 608.515,
    rx: 390.478,
    ry: 10.2434,
    transform: "rotate(89.221 498.929 608.515)",
    fill: "url(#paint2_linear_2131_17522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21533",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.5,
    filter: "url(#filter3_f_2131_17522)"
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.836,
    cy: 616.755,
    rx: 390.478,
    ry: 10.2434,
    transform: "rotate(87.5515 513.836 616.755)",
    fill: "url(#paint3_linear_2131_17522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21529",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter4_f_2131_17522)"
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 449.374,
    cy: 476.504,
    rx: 400.031,
    ry: 52.4605,
    transform: "rotate(97.971 449.374 476.504)",
    fill: "url(#paint4_linear_2131_17522)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21531",
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.4,
    filter: "url(#filter5_f_2131_17522)"
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.91,
    cy: 429.426,
    rx: 336.805,
    ry: 52.3347,
    transform: "rotate(104.002 457.91 429.426)",
    fill: "url(#paint5_linear_2131_17522)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2131_17522",
    x: 338.947,
    y: 100.02,
    width: 403.111,
    height: 874.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2131_17522",
    x: 431.918,
    y: 183.895,
    width: 121.01,
    height: 822.277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2131_17522",
    x: 463.391,
    y: 194.074,
    width: 71.0781,
    height: 828.883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2131_17522",
    x: 470.264,
    y: 202.633,
    width: 87.1465,
    height: 828.246,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2131_17522",
    x: 293.371,
    y: 0.269531,
    width: 312.006,
    height: 952.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2131_17522",
    x: 321.877,
    y: 62.3789,
    width: 272.064,
    height: 734.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2131_17522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2131_17522",
    x1: 286.24,
    y1: 483.413,
    x2: 461.505,
    y2: 807.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A780E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2131_17522",
    x1: 196.629,
    y1: 580.688,
    x2: 210.252,
    y2: 690.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A780E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2131_17522",
    x1: 187.759,
    y1: 601.057,
    x2: 191.3,
    y2: 658.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A780E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2131_17522",
    x1: 202.666,
    y1: 609.296,
    x2: 206.207,
    y2: 667.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A780E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2131_17522",
    x1: 130.591,
    y1: 438.306,
    x2: 213.807,
    y2: 710.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E59D",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2131_17522",
    x1: 189.512,
    y1: 391.32,
    x2: 284.59,
    y2: 653.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80E59D",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D20BF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "waterEffect",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.01 0.02",
    numOctaves: 2,
    result: "turbulence"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "baseFrequency",
    values: "0.01 0.02;0.02 0.03;0.01 0.02",
    dur: "15s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in2: "turbulence",
    in: "SourceGraphic",
    scale: 3,
    xChannelSelector: "R",
    yChannelSelector: "G"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRayComponents);
export default __webpack_public_path__ + "static/media/StartRayComponents.cdab105222ab8cdf3c85591cb5aa3f64.svg";
export { ForwardRef as ReactComponent };